/* eslint-disable no-unused-vars */
import React from 'react';
import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState, useContext, useEffect } from "react";
import { AppContext } from "../context/AppContext";
import { useNavigate } from "react-router-dom";
import LegalDocument from './LegalDocument.js';
import logo from "../images/logo.png";
import Cookies from 'js-cookie';

export default function LegalPapers() {

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [dragging, setDragging] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [partnerEmail, setPartnerEmail] = useState("");
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const {
    user,
    saveUser,
  } = useContext(AppContext);

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  const handleSubmit = async () => {
    console.log(uploadedFiles);

    submitImages(uploadedFiles);
  };

  const handleDrop = (e, index) => {
    e.preventDefault();
    setDragging(false);
    const files = Array.from(e.dataTransfer.files);

    setUploadedFiles((prevUploadedFiles) => {
      const updatedFiles = [...prevUploadedFiles];
      updatedFiles[index] = files[0];
      const progress = (updatedFiles.filter(Boolean).length / 7) * 100;
      setUploadProgress(Math.round(progress));
      console.log(updatedFiles);
      return updatedFiles;
    });
  };

  const handleCancel = () => {
    setOpen(false);
    navigate('/');
  };

  const handleFileUpload = (event, index) => {
    const files = event.target.files;

    setUploadedFiles((prevUploadedFiles) => {
      const updatedFiles = [...prevUploadedFiles];
      updatedFiles[index] = files[0];
      const progress = (updatedFiles.filter(Boolean).length / 7) * 100;
      setUploadProgress(Math.round(progress));
      console.log(updatedFiles);
      return updatedFiles;
    });
  };

  const submitImages = async (files) => {
    try {
      console.log(files);
      const formData = new FormData();

      files.forEach((file) => {
        console.log(file);
        formData.append('file', file);
      });
      console.log(formData);
      const token = Cookies.get("token");
      const response = await fetch(`http://0.0.0.0:3001/upload`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        console.error(response);
        throw new Error("Failed to upload file");
      }
      setUploadSuccess(true);
      // getImage();
    } catch (error) {
      console.error("Error uploading files:", error);
    }
  };

  useEffect(() => {
    // Check if user exists and has a partnerId
    if (user && !user.partnerId) {
      setOpen(true); // Show invite popup if partnerId doesn't exist
    }
  }, [user]);

  const InvitePartner = async (e) => {
    e.preventDefault();
  
    try {
      const token = Cookies.get("token");
  
      if (partnerEmail === user.email) {
        setErrorMessage("You can't enter your email, please ensure it's your partner's email.");
        return;
      }
      
      if (!partnerEmail || !user._id) {
        setErrorMessage("Email address is required.");
        return;
      }
  
      const response = await fetch(`${process.env.REACT_APP_ADDRESS}/users/invitePartner/${partnerEmail}/${user._id}`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
  
      if (response.status === 200) {
        setErrorMessage("");
        setOpen(false);
  
        // Fetch user data after successful invitation
        const userResponse = await fetch(`${process.env.REACT_APP_ADDRESS}/users/getOne/${user._id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
  
        if (userResponse.ok) {
          const userData = await userResponse.json();
          saveUser(userData);
        } else {
          setErrorMessage("Failed to fetch user data.");
        }
      } else if (response.status === 404) {
        setErrorMessage("Email not found.");
      } else if (response.status === 400) {
        setErrorMessage("Bad request, please refresh the page.");
      } else {
        setErrorMessage("Internal server error.");
      }
    } catch (error) {
      setErrorMessage("An unexpected error occurred.");
    }
  };

  const onInputChange = (e) => {
    setFile(e.target.files[0]);
  };

  const getImage = async () => {
    try {
      const token = Cookies.get("token");
      console.log(token);

      const response = await fetch(`/get-file`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error("Failed to fetch images");
      }
      const result = await response.json();
      setAllImage(result.data);
      console.log(result.data);
    } catch (error) {
      console.error("Error fetching images:", error);
    }
  };

  const toggleSelectedItems = (index) => {
    setCurrent(index);
    setUploadProgress(0);
    setUploadedFiles([]);
    // setSelectedFiles([]);
  };

  return (
    <>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 overflow-y-auto z-50"
          onClose={setOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="fixed inset-0 flex items-center justify-center">
              <div className="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:max-w-lg w-full">
                <div className="px-6 py-4">
                  <div className="text-center">
                    <div className="flex justify-center">
                      <img className="h-auto w-28" src={logo} alt="logo" />
                    </div>

                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900"
                    >
                      Invite your partner.
                    </Dialog.Title>
                    <div className="mt-2 max-w-xl text-sm text-gray-500">
                      <p>
                        Invite your partner so you can upload your Legal Documents.
                      </p>
                    </div>
                  </div>

                  <form className="mt-5">
                    <div className="mb-4">
                      <label
                        htmlFor="email"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Email
                      </label>
                      <input
                        type="email"
                        name="email"
                        id="email"
                        className="mt-1 block w-full shadow-sm sm:text-sm focus:ring-[#EF6575] focus:border-[#EF6575] border-gray-300 rounded-md"
                        placeholder="you@example.com"
                        value={partnerEmail}
                        onChange={(e) => setPartnerEmail(e.target.value)} />
                    </div>

                    <div className="flex justify-end">
                      <button
                        type="button"
                        className="mr-2 inline-flex justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-transparent rounded-md hover:bg-gray-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-pink-500"
                        onClick={handleCancel}
                      >
                        Cancel
                      </button>
                      <button
                        className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-[#F25668] border border-transparent rounded-md shadow-sm hover:bg-[#EF6575] focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-pink-500"
                        onClick={InvitePartner}
                      >
                        Invite
                      </button>
                    </div>
                  </form>
                  {errorMessage && (
                    <div className="rounded-md bg-red-50 p-4 mt-6">
                      <div className="flex">
                        <div className="flex-shrink-0">
                          <svg
                            className="h-5 w-5 text-red-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              fillRule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z"
                              clipRule="evenodd" />
                          </svg>
                        </div>
                        <div className="ml-3">
                          <h3 className="text-sm font-medium text-red-800">
                            {errorMessage}
                          </h3>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Transition.Child>
        </Dialog>
      </Transition.Root>
      <form onSubmit={handleSubmit}>
        <div className="space-y-8">
          <h2 className="text-2xl font-semibold leading-7 text-gray-900">
            File Checklist
          </h2>
          <p className="max-w-md text-sm leading-6 text-gray-600">
            You can upload your marriage files here.
          </p>
          {/* Progress Bar */}
          <div className="relative mt-8">
            <div className="flex items-center justify-between mb-2">
              <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-pink-600 bg-pink-200">
                Upload Progress
              </span>
              <span className="text-xs font-semibold text-pink-600">
                {uploadProgress}%
              </span>
            </div>
            <div className="overflow-hidden h-2 mb-2 text-xs flex rounded bg-gradient-to-r from-pink-400 via-purple-500 to-indigo-500">
              <div
                style={{ width: `${uploadProgress}%` }}
                className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-pink-600 transition-width duration-500"
              ></div>
            </div>
          </div>
          <div
            className={`grid grid-cols-1 sm:grid-cols-4 gap-6 ${dragging ? "border-dashed border-4 border-gray-400" : ""}`}
            onDragOver={handleDragOver}
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
          >
            {Array.from({ length: 7 }).map((_, index) => (
              <LegalDocument
                key={index}
                index={index}
                uploadedFiles={uploadedFiles}
                handleDrop={handleDrop}
                handleFileUpload={handleFileUpload} />
            ))}
          </div>
          <div className="flex justify-end">
            <button
              type="button"
              className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white py-2 px-6 rounded-full transition duration-300 hover:from-purple-700 hover:to-indigo-700"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
          {uploadSuccess && (
            <div className="text-green-500">Upload successful!</div>
          )}
        </div>
      </form>
    </>
  );
}
